import React from "react";
import { useTranslation } from "react-i18next";
import type { HeatmapViewMode } from "../../types/gazeHeatmapTypes";

interface ViewModeToggleProps {
  viewMode: HeatmapViewMode;
  onChange: (mode: HeatmapViewMode) => void;
  disabled?: boolean;
  flatDisabled?: boolean; // Disable flat mode (e.g., for videos)
}

/**
 * Toggle component to switch between flat (equirectangular) and interactive 360° view modes
 */
const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  viewMode,
  onChange,
  disabled = false,
  flatDisabled = false,
}) => {
  const { t } = useTranslation();

  const isFlatDisabled = disabled || flatDisabled;

  return (
    <div className="inline-flex rounded-lg border border-gray-300 bg-gray-100 p-0.5">
      <button
        type="button"
        onClick={() => onChange("flat")}
        disabled={isFlatDisabled}
        title={flatDisabled ? t("statsNew.gazeHeatmap.flatNotAvailableForVideo") : undefined}
        className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
          viewMode === "flat"
            ? "bg-white text-gray-900 shadow-sm"
            : "text-gray-500 hover:text-gray-700"
        } ${isFlatDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
      >
        {t("statsNew.gazeHeatmap.viewFlat")}
      </button>
      <button
        type="button"
        onClick={() => onChange("360")}
        disabled={disabled}
        className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
          viewMode === "360"
            ? "bg-white text-gray-900 shadow-sm"
            : "text-gray-500 hover:text-gray-700"
        } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      >
        {t("statsNew.gazeHeatmap.view360")}
      </button>
    </div>
  );
};

export default ViewModeToggle;
